// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__2NTjZ","value":"styles_value__11wgB"};